import { render } from "./bar.vue?vue&type=template&id=314cfc19&ts=true"
import script from "./bar.vue?vue&type=script&lang=ts"
export * from "./bar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__